module.exports = __webpack_public_path__ + "img/clock.9904b009.svg";